import React, { useEffect, useState } from 'react';
import { expensesApi } from '../api';
import SubscriptionBanner from './SubscriptionBanner';

export default function Categories({ user, subStatus, onSubscribe }) {
  const [expCats, setExpCats] = useState([]);
  const [incCats, setIncCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showExpModal, setShowExpModal] = useState(false);
  const [showIncModal, setShowIncModal] = useState(false);
  const [newExpName, setNewExpName] = useState('');
  const [newIncName, setNewIncName] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const [exp, inc] = await Promise.all([
        expensesApi.listUnifiedCustom('expense').catch(()=>[]),
        expensesApi.listUnifiedCustom('income').catch(()=>[]),
      ]);
      setExpCats(Array.isArray(exp)? exp: []);
      setIncCats(Array.isArray(inc)? inc: []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 p-4 font-sans">
      <div className="text-xl font-bold mb-4">Categories</div>

      <SubscriptionBanner 
        user={user} 
        subStatus={subStatus} 
        onSubscribe={onSubscribe}
        showCreateButton={true}
        quotaInfo={subStatus?.quotaInfo}
      />

      <div className="flex items-center justify-end mb-3">
        <button 
          className="text-sm bg-green-600 text-white px-3 py-2 rounded-full shadow" 
          onClick={()=> {
            // Check if subscription is inactive
            if (subStatus?.valid === false) {
              onSubscribe?.();
              return;
            }
            // Check if trial user has exceeded quota
            if (subStatus?.plan === 'trial' && subStatus?.quotaInfo?.quotaExceeded) {
              onSubscribe?.();
              return;
            }
            setShowExpModal(true);
          }}
        >
          + Add Category
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Expenses */}
        <section className="bg-white border border-green-100 rounded-2xl p-3 shadow-sm">
            <div className="text-sm font-semibold mb-2">Expense Categories</div>
          {loading ? <div className="text-xs text-gray-500">Loading…</div> : (
            <ul className="divide-y">
              {expCats.map((c) => (
                <li key={c.categoryId} className="py-2 flex items-center justify-between">
                  <div className="text-sm text-gray-800">{c.name}</div>
                  <button className="text-xs text-green-700 underline" onClick={async ()=>{
                    const name = window.prompt('Rename category', c.name);
                    if (!name) return;
                    await expensesApi.updateUnified(c.categoryId, name);
                    await load();
                  }}>Edit</button>
                </li>
              ))}
              {expCats.length === 0 && <li className="py-2 text-xs text-gray-500">No custom categories yet</li>}
            </ul>
          )}
        </section>

        {/* Income */}
        <section className="bg-white border border-green-100 rounded-2xl p-3 shadow-sm">
            <div className="text-sm font-semibold mb-2">Income Categories</div>
          {loading ? <div className="text-xs text-gray-500">Loading…</div> : (
            <ul className="divide-y">
              {incCats.map((c) => (
                <li key={c.categoryId} className="py-2 flex items-center justify-between">
                  <div className="text-sm text-gray-800">{c.name}</div>
                  <button className="text-xs text-green-700 underline" onClick={async ()=>{
                    const name = window.prompt('Rename category', c.name);
                    if (!name) return;
                    await expensesApi.updateUnified(c.categoryId, name);
                    await load();
                  }}>Edit</button>
                </li>
              ))}
              {incCats.length === 0 && <li className="py-2 text-xs text-gray-500">No custom categories yet</li>}
            </ul>
          )}
        </section>
      </div>

      {/* Add modals */}
      {(showExpModal || showIncModal) && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-green-900/10">
          <div className="w-full sm:w-[380px] bg-white rounded-t-2xl sm:rounded-2xl shadow-xl border border-green-100">
            <div className="p-3 border-b border-green-100 flex items-center justify-between">
              <div className="text-sm font-semibold text-gray-800">Add Category</div>
              <button className="text-sm text-gray-500" onClick={()=> { setShowExpModal(false); setShowIncModal(false); }}>✕</button>
            </div>
            <div className="p-3">
              <div className="mb-2">
                <div className="text-xs text-gray-600 mb-1">Type</div>
                <select className="w-full border rounded px-3 py-2 text-sm" value={showIncModal ? 'income' : 'expense'} onChange={(e)=>{ const v = e.target.value; if (v==='income') { setShowIncModal(true); setShowExpModal(false); } else { setShowExpModal(true); setShowIncModal(false); } }}>
                  <option value="expense">Expense</option>
                  <option value="income">Income</option>
                </select>
              </div>
              <input className="w-full border rounded px-3 py-2 text-sm" placeholder="Category name" value={showIncModal ? newIncName : newExpName} onChange={(e)=>{ const v=e.target.value; if (showIncModal) setNewIncName(v); else setNewExpName(v); }} />
            </div>
            <div className="p-3 flex gap-2">
              <button className="flex-1 bg-green-600 text-white rounded-xl py-2 text-sm shadow" onClick={async ()=>{ const isIncome = !!showIncModal; const n = (isIncome? newIncName : newExpName).trim(); if (!n) return; await expensesApi.createUnified({ name: n, type: isIncome?'income':'expense' }); setNewIncName(''); setNewExpName(''); setShowExpModal(false); setShowIncModal(false); await load(); }}>Save</button>
              <button className="flex-1 bg-white border border-green-200 text-green-700 rounded-xl py-2 text-sm" onClick={()=> { setShowExpModal(false); setShowIncModal(false); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


